
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  RqthDeclarationResource,
} from '../models';
import {
    RqthDeclarationResourceFromJSON,
    RqthDeclarationResourceToJSON,
} from '../models';

export interface GetRqthDeclarationRequest {
    accountId: string;
}

export interface SubmitRqthDeclarationRequest {
    accountId: string;
    file: Blob;
    badgeEnabled: boolean;
    expiryDate?: Date | null;
}

export interface WithdrawRqthDeclarationRequest {
    accountId: string;
}

/**
 * 
 */
export class RqthApi extends runtime.BaseAPI {

    /**
     * Get the active RQTH declaration for a freelancer account
          */
    async getRqthDeclarationRaw(requestParameters: GetRqthDeclarationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<RqthDeclarationResource>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getRqthDeclaration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<RqthDeclarationResource>({
            path: `/compliance/api/accounts/{accountId}/rqth`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=RqthDeclarationResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get the active RQTH declaration for a freelancer account
          */
    async getRqthDeclaration(requestParameters: GetRqthDeclarationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<RqthDeclarationResource> {
        const response = await this.getRqthDeclarationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Submit an RQTH declaration for a freelancer account
          */
    async submitRqthDeclarationRaw(requestParameters: SubmitRqthDeclarationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling submitRqthDeclaration().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling submitRqthDeclaration().'
            );
        }

        if (requestParameters['badgeEnabled'] == null) {
            throw new runtime.RequiredError(
                'badgeEnabled',
                'Required parameter "badgeEnabled" was null or undefined when calling submitRqthDeclaration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['expiryDate'] != null) {
            formParams.append('expiryDate', requestParameters['expiryDate'] as any);
        }

        if (requestParameters['badgeEnabled'] != null) {
            formParams.append('badgeEnabled', requestParameters['badgeEnabled'] as any);
        }

        const response = await this.request<void>({
            path: `/compliance/api/accounts/{accountId}/rqth`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return response;
    }

    /**
     * Submit an RQTH declaration for a freelancer account
          */
    async submitRqthDeclaration(requestParameters: SubmitRqthDeclarationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.submitRqthDeclarationRaw(requestParameters, initOverrides);
    }

    /**
     * Withdraw the active RQTH declaration for a freelancer account
          */
    async withdrawRqthDeclarationRaw(requestParameters: WithdrawRqthDeclarationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling withdrawRqthDeclaration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/accounts/{accountId}/rqth`.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Withdraw the active RQTH declaration for a freelancer account
          */
    async withdrawRqthDeclaration(requestParameters: WithdrawRqthDeclarationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.withdrawRqthDeclarationRaw(requestParameters, initOverrides);
    }

}
